// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__qxyQN","header":"MessagesList_header__VC46M","chat":"MessagesList_chat__3hTr1"};